import styled from "styled-components";

export const Container = styled.div`
  padding: 22px 14px;
  background: #FFCECE;
  border-radius: 8px;
`;
